import { useOrderFormStore } from '@/stores/forms/orderFormStore';
import { useGlobalStore } from '@/stores/globalStore';

import useMerchApiEndpoints from '@/composables/api/useMerchApiEndpoints';
import useAutomaticRedirect from '@/composables/helpers/automaticRedirect';
import useCreateDefaultsFromApi from '@/composables/api/useCreateDefaultsFromApi';

const shouldRedirectToVerificationKyb = () => {
  const globalStore = useGlobalStore();
  const orderStore = useOrderFormStore();
  const hasEmail = !!orderStore.merchApiOrderData?.email;

  return !hasEmail && globalStore?.getMerchantSettings?.msisdnRequired;
};

const shouldRedirectToVerificationCodeKyb = () => {
  const globalStore = useGlobalStore();
  const orderStore = useOrderFormStore();
  const hasEmail = !!orderStore.merchApiOrderData?.email;

  return hasEmail && globalStore?.getMerchantSettings?.VALIDATE_EMAIL;
};

const handleApiRedirect = async (routerRef, fromRoute) => {
  const globalStore = useGlobalStore();
  const orderStore = useOrderFormStore();
  const { getApiOrder, getPAPIOrder } = useMerchApiEndpoints();
  const { redirectForApiOrders } = useAutomaticRedirect();
  const {
    isAnApiOrder, isPapiOrder, checkApiForOrderTypeAndSetMode, checkApiToSetPaymentType,
  } = useCreateDefaultsFromApi();

  if (isAnApiOrder()) {
    const merchRes = await (isPapiOrder()
    ? getPAPIOrder()
    : getApiOrder());

    // NOTE: setMerchApiData, checkApiForOrderTypeAndSetMode and
    // checkApiToSetPaymentType order should not be changed
    orderStore.setMerchApiData(merchRes.data);
    await checkApiForOrderTypeAndSetMode();
    checkApiToSetPaymentType();

    const isAnApplePayOrder = await orderStore.checkUserApplePaySession();

    if ((!!isAnApplePayOrder && orderStore.canSkipOrderPageFromApiData)
      || orderStore.canSkipOrderPageFromApiData
    ) {
      await redirectForApiOrders(routerRef, fromRoute);
    }
  }

  if (
    globalStore.getIsKyb
    && !fromRoute?.name?.includes('verification')
    && !fromRoute?.name?.includes('identity')
    && shouldRedirectToVerificationKyb()
  ) {
    routerRef.push('/verification');
    return;
  }

  if (
    globalStore.getIsKyb
    && !fromRoute?.name?.includes('verification')
    && !fromRoute?.name?.includes('identity')
    && shouldRedirectToVerificationCodeKyb()
  ) {
    routerRef.push('/verification/code');
  }
};

export {
	handleApiRedirect,
};
